export const parentChildCheckboxesBehavior = (e) => {
    if (e.sender._allCheckedItems.length == 0) {
        return false;
    }
    const node = e.sender.tree.find('li[id]');
    const item = e.sender.element.data('kendoDropDownTree').dataItem(node);
    if (item) {
        checkChildren(item);
    }
}

const checkChildren = (item) => {
    if (item.hasChildren) {
        if (item.items && item.items.length > 0) {
            item.items.forEach((child) => {
                child.set('checked', item.checked)
                checkChildren(child);
            });
        }
    }
}